import React, { useState, useEffect } from "react";
import {
  fetchMultibetDataApi,
  fetchMultibetmarketsDataApi,
  // fetchMultibetleaguesDataApi,
  fetchMultibetReplaceDataApi,
} from "../api/api";
import { formatDate, formatValue, totalOddsCal } from "../helper/index";
import LeagueMultiSelect from "../component/Multibet/LeagueMultiSelect";
import MarketMultiSelect from "../component/Multibet/MarketMultiSelect";
import { useNavigate } from "react-router-dom";

const BETWAY_URL = process.env.REACT_APP_BETWAY;

function MultiBets({ oddsFormat, leagueData, language, subscriptionStatus }) {
  const [bet, setBet] = useState("10");
  const [count, setCount] = useState(4);
  const [marketBetbuilderArray, setMarketBetbuilderArray] = useState([]);
  // const [isLoadingLeagueData, setIsLoadingLeagueData] = useState(false);
  const [isLoadingMatchData, setIsLoadingMatchData] = useState(false);
  const [isLoadingSearchData, setIsLoadingSearchData] = useState(true);
  const [totalOdds, setTotalOdds] = useState("");
  const [shouldProcessData, setShouldProcessData] = useState(true);
  const [selection, setSelection] = useState("");
  const [mastermarketid, setMastermarketid] = useState("");
  // const [leagueData, setLeagueData] = useState([]);
  const [leagueId, setLeagueId] = useState("");
  const [marketData, setMarketData] = useState([]);
  const [alertMessage, setAlertMessage] = useState("");
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [refreshloading, setRefreshloading] = useState(false);
  const navigate = useNavigate();


  const handleClick = () => {
    navigate("/pricing");
  };


  const options = [
    { label: `£ ${2 * bet} - ${5 * bet}`, value: `${2 * bet}-${5 * bet}` },
    { label: `£ ${5 * bet} - ${10 * bet}`, value: `${5 * bet}-${10 * bet}` },
    { label: `£ ${10 * bet} - ${50 * bet}`, value: `${10 * bet}-${50 * bet}` },
    {
      label: `£ ${50 * bet} - ${100 * bet}`,
      value: `${50 * bet}-${100 * bet}`,
    },
    {
      label: `£ ${100 * bet} - ${500 * bet}`,
      value: `${100 * bet}-${500 * bet}`,
    },
    {
      label: `£ ${500 * bet} - ${1000 * bet}`,
      value: `${500 * bet}-${1000 * bet}`,
    },
  ];

  const [win, setWin] = useState(options[0].value);

  const handleBetChange = (e) => {
    const value = e.target.value;
    setBet(value === "" ? "" : Math.max(1, parseInt(value, 10)));
  };

  const handleNoOfSelectionsLocal = (e) => {
    setCount(e.target.value);
    handleSearchClick(e.target.value, win);
  };

  const handleWinAmount = (windata) => {
    const selectedWinAmount = windata;
    setWin(selectedWinAmount);

    // Mapping object for bet ranges
    const winRanges = {
      [`${2 * bet}-${5 * bet}`]: 3,
      [`${5 * bet}-${10 * bet}`]: 4,
      [`${10 * bet}-${50 * bet}`]: 5,
      [`${50 * bet}-${100 * bet}`]: 6,
      [`${100 * bet}-${500 * bet}`]: 7,
      [`${500 * bet}-${1000 * bet}`]: 8,
    };

    // Set count if matched, otherwise default to 0
    const newCount = winRanges[selectedWinAmount] || 0;
    setCount(newCount);

    // Only trigger search if a valid count is set
    if (newCount > 0) {
      handleSearchClick(newCount, selectedWinAmount);
    }
  };

  const handleSearchClick = async (count, winAmount) => {
    setIsLoadingSearchData(true);
    setMarketBetbuilderArray([])
    setTotalOdds("");
    try {
      const resDataBetBuilder = await fetchMultibetDataApi(
        count,
        winAmount,
        bet,
        mastermarketid,
        leagueId,
        language
      );

      if (resDataBetBuilder?.data?.length > 0) {
        const totalOdds = totalOddsCal(oddsFormat, resDataBetBuilder.data, true)
        setTotalOdds(totalOdds);
        setMarketBetbuilderArray(resDataBetBuilder.data);
        // setTotalOdds(resDataBetBuilder.totalodds);
      } else {
        setMarketBetbuilderArray([]);
      }
    } catch (error) {
      console.error("Error fetching bet builder data:", error);
    } finally {
      setIsLoadingSearchData(false);
    }
  };

  useEffect(() => {
    if (shouldProcessData || leagueId || mastermarketid || language) {
      const fetchData = async () => {
        // setIsLoadingSearchData(true);
        setMarketBetbuilderArray([])
        setTotalOdds("");

        try {
          const resDataBetBuilder = await fetchMultibetDataApi(
            count,
            win,
            bet,
            mastermarketid,
            leagueId,
            language
          );

          if (resDataBetBuilder && resDataBetBuilder.data.length > 0) {
            const totalOdds = totalOddsCal(oddsFormat, resDataBetBuilder.data, true)
            setTotalOdds(totalOdds);
            setMarketBetbuilderArray(resDataBetBuilder.data);
            setIsLoadingSearchData(false);

          } else {
            setIsLoadingSearchData(false);
          }
        } catch (error) {
          console.error("Error fetching bet builder data:", error);
        } finally {
          setIsLoadingSearchData(false);
        }
      };

      fetchData();
      setShouldProcessData(false);
    }
  }, [language, shouldProcessData, count, bet, win, mastermarketid, leagueId, oddsFormat]);


  useEffect(() => {
    const fetchMarketData = async () => {
      try {
        setIsLoadingMatchData(true);
        const marketData = await fetchMultibetmarketsDataApi(language);
        const data = marketData.data;
        setMarketData(data);
        setIsLoadingMatchData(false);
      } catch (error) {
        console.error("Error fetching league data:", error);
        setIsLoadingMatchData(false);
      }
    };
    fetchMarketData();
  }, [language]);

  useEffect(() => {
  if (marketBetbuilderArray.length > 0) {
    const updatedTotalOdds = totalOddsCal(oddsFormat, marketBetbuilderArray, true);
    setTotalOdds(updatedTotalOdds);
  }
}, [oddsFormat, marketBetbuilderArray]);

  const handleBetBuilderRefresh = async (
    event,
    matchid,
    minodds,
    maxodds,
    leagueId,
    mastermarketid
  ) => {
    event.stopPropagation();
    // setRowLoading((prev) => ({ ...prev, [matchid]: true }));

    // console.log(leagueId)
    try {
      setRefreshloading(true)
      const excludedMatchIds = marketBetbuilderArray
        .map((item) => item.matchid)
        .join(",");
      const resDataBetBuilder = await fetchMultibetReplaceDataApi(
        excludedMatchIds,
        minodds,
        maxodds,
        leagueId,
        mastermarketid,
        language
      );

      if (resDataBetBuilder.statuscode === 404) {
        setRefreshloading(false)
        setAlertMessage((prevMessages) => ({
          ...prevMessages,
          [matchid]: "No replacement available",
        }));
        setTimeout(() => {
          setAlertMessage((prevMessages) => {
            const updatedMessages = { ...prevMessages };
            delete updatedMessages[matchid];
            return updatedMessages;
          });
        }, 3000);
      } else {
        const updatedRowData = resDataBetBuilder.data;

        if (updatedRowData && updatedRowData.length > 0) {
          setMarketBetbuilderArray((prevData) => {
            const newData = [
              ...prevData.filter((item) => item.matchid !== matchid),
              ...updatedRowData,
            ];

            const totalOdds = totalOddsCal(oddsFormat, newData, true)

            setTotalOdds(totalOdds);

            return newData;
          });
          setRefreshloading(false)
        } else {
          setRefreshloading(false)
          setAlertMessage((prevMessages) => ({
            ...prevMessages,
            [matchid]: "No replacement available",
          }));

          setTimeout(() => {
            setAlertMessage((prevMessages) => {
              const updatedMessages = { ...prevMessages };
              delete updatedMessages[matchid];
              return updatedMessages;
            });
          }, 3000);
        }
      }
    } catch (error) {
      console.error("Error refreshing bet builder data:", error);
    } finally {
      // setRowLoading((prev) => ({ ...prev, [matchid]: false }));
    }
  };


  return (
    <>
      <div className="AF-widget AF-winBig" style={{position:'relative'}}>
        <div className="AF-widget__header">
          <div className="grid-noGutter-middle">
            <div className="col-8">
              <span className="AF-widget__title">MULTIBET</span>{" "}
              <span className="tooltip-wrapper-multibet-title">
                <img src="assets/images/fire-icon.svg" alt="fire-icon" className="fire-icon" />
                <span className="tooltip-text-multibet-title">
                  We generate an instant multiple based on your chosen win amount.
                </span>
              </span>
            </div>
            {/* <div className="col-4 text-right">
						<span className="AF-widget__showAll">Show all</span>
					</div> */}
          </div>
        </div>
        <div className="AF-widget__filterSection">
          <ul className="AF-widget__winBigFilters AF-widget__winBigFilters_new">
            <li className="AF-filterBet">
              <div className="AF-formControl">
                {/* <div className="AF-formLabel-NEW">How much do you want to win?</div> */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    marginTop: "2px",
                  }}
                >
                  <div className="stake_size">
                    How much do you want to win?
                    <span className="tooltip-wrapper">
                      <span className="info-icon">ℹ</span>
                      <span className="tooltip-text">Based on a £10 stake</span>
                    </span>
                  </div>

                  {/* <input
                    type="number"
                    className="input-new"
                    id="input_multibet_stake"
                    value={bet}
                    onChange={(e) => {
                      const val = parseInt(e.target.value, 10);
                      if (!isNaN(val) && val >= 1 && val<=3000 ) {
                        handleBetChange(e);
                      } else if (e.target.value === "") {
                        handleBetChange(e);
                      }
                    }}
                    min={1}
                    step={1}
                    max={3000}
                  /> */}
                </div>

              </div>
            </li>
          </ul>

          <ul className="AF-widget__winBigFilters AF-widget__winBigFilters_new">
            {/* <div className="AF-formLabel">How much do you want to win?</div> */}
            <div className="bet-button-grid">
              {options.map((option, index) => (
                <button
                  key={index}
                  className={`bet-button ${
                    win === option.value ? "active" : ""
                  }`}
                  onClick={() => handleWinAmount(option.value)}
                  id="btn_multibet_winamout"
                >
                  {option.label}
                </button>
              ))}
            </div>
          </ul>
          {/* <div className="AF-advancedToggle">
          <button
                className="advanced-toggle-btn"
                onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
              >
                {showAdvancedFilters ? "Hide Advanced Filters ▲" : "Show Advanced Filters ▼"}
              </button>
          </div> */}
          <div className="AF-advancedToggle" style={{ position: "relative" }}>
            {subscriptionStatus === "Active" ? (
              <button
                className="advanced-toggle-btn"
                onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
              >
                {showAdvancedFilters ? "Hide Advanced Filters ▲" : "Show Advanced Filters ▼"}
              </button>
            ) : (
              <div className="locked-advanced-filters" title="Upgrade to Pro to unlock league, market, and leg filters." onClick={handleClick}>
                <button  className="advanced-toggle-btn disabled" >
                  Show Advanced Filters ▼
                </button>
                <div className="lock-overlay-multibet">
                  <span class="lock-icon">🔒</span>
                </div>
              </div>
            )}
          </div>

          {showAdvancedFilters && (
            <>
          
          <ul className="AF-widget__winBigFilters AF-widget__winBigFilters_new">
            <li className="AF-filterToWin">
              <div className="AF-formControl">
                <div className="AF-formLabel">Legs
                <div className="AF-select-multibet">
                  <select
                    className="truncate"
                    onChange={handleNoOfSelectionsLocal}
                    value={count}
                    id="select_multibet_leg"
                  >
                    <option value={3}>3</option>
                    <option value={4}>4</option>
                    <option value={5}>5</option>
                    <option value={6}>6</option>
                    <option value={7}>7</option>
                    <option value={8}>8</option>
                  </select>
                </div>
                <span className="tooltip-wrapper">
                      <span className="info-icon">ℹ</span>
                      <span className="tooltip-text">Click to swap this pick for an alternative from the same odds range.</span>
                    </span>
                </div>
              </div>
            </li>
          </ul>
          <div className="AF-widget__winBigFilters_container">
            <ul className="AF-widget__winBigFilters AF-widget__winBigFilters_filter">
              <span className="">Filter by:</span>
              <li className="AF-widget_winbig_li">
                <input
                  type="radio"
                  id="radio_multibet_league"
                  name="filter"
                  value="league"
                  checked={selection === "league"}
                  onChange={() => {
                    setSelection("league");
                    setMastermarketid("");
                  }}
                />
                <span className="AF-widget_winbig_span">League</span>
              </li>
              <li className="AF-widget_winbig_li">
                <input
                  type="radio"
                  id="radio_multibet_market"
                  name="filter"
                  value="market"
                  checked={selection === "market"}
                  onChange={() => {
                    setSelection("market");
                    setLeagueId("");
                  }}
                />
                <span className="AF-widget_winbig_span">Market</span>
              </li>
              <li className="AF-widget_winbig_li">
                <svg
                  className="icon_new"
                  viewBox="0 0 30 30"
                  id="referesh_multibet_league_market"
                  onClick={() => {
                    setSelection("");
                    setLeagueId("");
                    setMastermarketid("");
                  }}
                >
                  <path d="M 15 3 C 12.031398 3 9.3028202 4.0834384 7.2070312 5.875 A 1.0001 1.0001 0 1 0 8.5058594 7.3945312 C 10.25407 5.9000929 12.516602 5 15 5 C 20.19656 5 24.450989 8.9379267 24.951172 14 L 22 14 L 26 20 L 30 14 L 26.949219 14 C 26.437925 7.8516588 21.277839 3 15 3 z M 4 10 L 0 16 L 3.0507812 16 C 3.562075 22.148341 8.7221607 27 15 27 C 17.968602 27 20.69718 25.916562 22.792969 24.125 A 1.0001 1.0001 0 1 0 21.494141 22.605469 C 19.74593 24.099907 17.483398 25 15 25 C 9.80344 25 5.5490109 21.062074 5.0488281 16 L 8 16 L 4 10 z"></path>
                </svg>
              </li>
            </ul>
          </div>
          <ul className="AF-widget__winBigFilters AF-widget__winBigFilters_new">
            <li className="AF-filterToWin">
              {selection === "league" && (
                <LeagueMultiSelect
                  leagueData={leagueData}
                  setLeagueId={setLeagueId}
                />
              )}

              {selection === "market" && (
                <MarketMultiSelect
                  marketData={marketData}
                  isLoadingLeagueData={isLoadingMatchData}
                  setMastermarketid={setMastermarketid}
                />
              )}
            </li>
          </ul>
          </>)}
        </div>
        {refreshloading && (
          <div className="trible-loading-overlay">
            <div className="spinner-loading"></div>
          </div>
        )}
        <div>
          {marketBetbuilderArray.length > 0 ? (
            <div className="AF-widget__content p-0">
              <div className="match-scroll-container">
              {marketBetbuilderArray.map((item, betIndex) => (
                <div className="AF-matchBox" key={betIndex}>
                  <div className="AF-matchBox__header">
                    {alertMessage[item.matchid] && (
                      <div className=" loading-container">
                        <div className="error-text">
                          {alertMessage[item.matchid]}
                        </div>
                      </div>
                    )}
                    <div className="grid-noGutter">
                      <div className="col-8 mut-size-title">
                        {item.countryname} - {item.leaguename}{" "}
                      </div>
                      <div className="col-4 text-right">
                        <span className="AF-matchBox__kickOff">
                          {formatDate(item.matchutcdatetime)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="AF-matchBox__content">
                    <div className="AF-matchBox__fixture AF-matchBox__fixture_new truncate">
                      <span className="match-name">{item.matchname}</span>
                      {subscriptionStatus === "Active" ? (
                        <span className="refresh-icon">
                          <svg
                            className="icon"
                            viewBox="0 0 30 30"
                            id="referesh_multibet_card"
                            onClick={(event) =>
                              handleBetBuilderRefresh(
                                event,
                                item.matchid,
                                item.minodds,
                                item.maxodds,
                                leagueId,
                                mastermarketid
                              )
                            }
                          >
                            <path d="M 15 3 C 12.031398 3 9.3028202 4.0834384 7.2070312 5.875 A 1.0001 1.0001 0 1 0 8.5058594 7.3945312 C 10.25407 5.9000929 12.516602 5 15 5 C 20.19656 5 24.450989 8.9379267 24.951172 14 L 22 14 L 26 20 L 30 14 L 26.949219 14 C 26.437925 7.8516588 21.277839 3 15 3 z M 4 10 L 0 16 L 3.0507812 16 C 3.562075 22.148341 8.7221607 27 15 27 C 17.968602 27 20.69718 25.916562 22.792969 24.125 A 1.0001 1.0001 0 1 0 21.494141 22.605469 C 19.74593 24.099907 17.483398 25 15 25 C 9.80344 25 5.5490109 21.062074 5.0488281 16 L 8 16 L 4 10 z"></path>
                          </svg>
                        </span>
                      ) : (
                        <span class="lock-icon" onClick={handleClick} title="Upgrade to Pro to unlock league, market, and leg filters." >🔒</span>
                      )}
                      
                    </div>
                    <div className="AF-matchBox__RTB">{item.keystats}</div>
                    {item.odds.decimalodds === null || item.odds.decimalodds === '1.01' || item.odds.decimalodds == 0 || item.odds.decimalodds === 1.01 ? 
                      <div className="email-error-msg">Odds currently unavailable</div>
                      :
                      <button className="btn AF-btnOdds AF-btnOddsDisabled">
                        <span className="AF-market">{item.bestbetname}</span>
                        <span className="AF-odds">
                          {oddsFormat==='EU' ? parseFloat(item.odds.decimalodds).toFixed(2) : formatValue(item.odds.americanodds)}
                        </span>
                      </button>
                    }
                  </div>
                </div>
              ))}
              </div>
            </div>
          ) : isLoadingSearchData ? (
            <div className="loading-container">
              <div className="spinner"></div>
            </div>
          ) : (
            <div className="loading-container">
              <div className="error-text">No data available</div>
            </div>
          )}
        </div>

        <div className="AF-widget__footer">
          <div className="grid-middle">
            <div className="col-6_lg-6_md-6_sm-6_xs-12 text-center">
              <div className="AF-totalOdds">
                <div className="AF-totalOdds__txt">Total Win Amount:</div>
                <div className="AF-totalOdds__value">
                  <span className="pound-size">£</span>{Number(totalOdds * bet).toFixed(2)}
                </div>
              </div>
            </div>
            <div className="col-6_lg-6_md-6_sm-6_xs-12">
              <a
                href={BETWAY_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={{textDecoration:'none'}}
              >            
              <ul className="AF-addAllToBetslip">
                {/* <span className="tooltip-wrapper-bestbuilder-title"> */}
                <li>
                  <img src="assets/images/betslip-icon.png" alt="betslip" />
                </li>
                <li className="slip-multi-li">Add all to Betslip</li>
                {/* <span className="tooltip-text-bestbuilder-title">
                  Betslip integration is coming soon.
                </span>
              </span> */}
              </ul>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MultiBets;
